import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "../add.module.css";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState } from "react";
import { useEffect } from "react";
import ProductComponent from "../../../../admin/pages/booking/add-booking/component/ProductComponent";
import DeliveryProductComponent from "../../../../admin/pages/booking/add-booking/component/DeliveryProductComponent";
import { authData } from "../../../../admin/components/GetAuth";

const Step1 = ({ saveStep1Data, bookingData }) => {
  const [isRegCompany, setIsRegCompany] = useState("");
  const [isDeliveryProducts, setIsDeliveryProducts] = useState(false);
  const [noOfItems, setNoOfItems] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;
  const [itemTotal, setItemTotal] = useState(0);
  const [deliveryItemTotal, setDeliveryItemTotal] = useState(0);
  const [allTotal, setAllTotal] = useState(0);
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [referralAmount, setReferralAmount] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);

  const { register, handleSubmit, control, formState: { errors }, setValue, clearErrors, watch, getValues } = useForm({
    mode: "onChange",
    defaultValues: {
      registered_company: "",
      company_shipping: "",
      company_name: "",
      insurance: "",
      pickup_date: dayjs(),
      notes: "",
      delivery_products: bookingData?.delivery_products ? bookingData?.delivery_products : [{ category_id: "", item_id: "", item_name: "", total: "", quantity: "", price: "", is_item: true }],
      products: bookingData?.products ? bookingData?.products : [{ category_id: "", item_id: "", item_name: "", total: "", is_fragile: false, is_item: true }]
    }
  });

  const { fields: fileds1, append: append1, remove: remove1, replace: replace1 } = useFieldArray({
    control,
    name: "delivery_products",
  });

  const { fields: fileds2, append: append2, remove: remove2, replace: replace2 } = useFieldArray({
    control,
    name: "products",
  });

  useEffect(() => {
    if (authData()?.customer && !bookingData) {
      setValue(`registered_company`, authData()?.customer?.registered_company);
      setIsRegCompany(authData()?.customer?.registered_company);

      if (authData()?.customer?.registered_company === "Yes") {
        setValue(`company_name`, authData()?.customer?.company_name);
        setValue(`company_shipping`, authData()?.customer?.company_shipping);
      }

      setReferralAmount(authData()?.customer?.referral_amount);

      if (authData()?.customer?.membership_discount) {
        setDiscountVal(parseFloat(authData()?.customer?.membership_discount));
      }
    }
    if (bookingData) {
      setDiscountVal(bookingData?.discountVal);

      let discountTemp = 0;
      let discountTemp2 = 0;

      if (typeof (bookingData?.discountAmount) !== 'undefined') {
        setDiscountAmount(bookingData?.discountAmount);
        discountTemp = bookingData?.discountAmount;
      }

      if (typeof (bookingData?.referralDiscount) !== 'undefined') {
        setReferralDiscount(bookingData?.referralDiscount);
        discountTemp2 = bookingData?.discountAmount;
      }

      setValue(`customer_id`, bookingData?.customer_id);
      setValue(`registered_company`, bookingData?.registered_company);
      setValue(`insurance`, bookingData?.insurance);
      setValue(`notes`, bookingData?.notes);
      setValue(`pickup_date`, dayjs(bookingData?.pickup_date));

      if (bookingData?.registered_company === "Yes") {
        setValue(`company_name`, bookingData?.company_name);
        setValue(`company_shipping`, bookingData?.company_shipping);
      }
      setIsRegCompany(bookingData?.registered_company);

      setValue(`is_delivery`, bookingData?.is_delivery);
      setIsDeliveryProducts(bookingData?.is_delivery);

      let allTotalTemp = 0;

      if (bookingData?.products) {
        let noOfI = 0;
        let itemT = 0;
        bookingData?.products.forEach((i) => {
          if (i?.total !== "") {
            noOfI++;
            itemT += parseFloat(i?.total);
          }
        });
        setNoOfItems(noOfI);
        setItemTotal(itemT);
        allTotalTemp += itemT;

        replace2(bookingData?.products);
      }

      if (bookingData?.is_delivery && bookingData?.delivery_products) {
        let itemT = 0;
        bookingData?.delivery_products.forEach((i) => {
          if (i?.total !== "") {
            itemT += parseFloat(i?.total);
          }
        });
        setDeliveryItemTotal(itemT);
        allTotalTemp += itemT;

        replace1(bookingData?.delivery_products);
      }
      setAllTotal(allTotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
    }
  }, [bookingData, replace1, replace2, setValue]);

  const cngProductVal = () => {
    let products = getValues("products");
    let noOfI = 0;
    let itemT = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;
    products.forEach((i) => {
      if (i?.total !== "") {
        noOfI++;
        itemT += parseFloat(i?.total);
      }
    });
    setNoOfItems(noOfI);
    setItemTotal(itemT);
    if (discountVal) {
      discountTemp = ((itemT * discountVal) / 100);
      if (discountTemp > parseInt(discountTemp)) {
        discountTemp = discountTemp.toFixed(2);
        discountTemp = parseFloat(discountTemp);
      }
      setDiscountAmount(discountTemp);
    }

    if (referralAmount) {
      var subtotaltemp = itemT - discountTemp;
      if (subtotaltemp >= referralAmount) {
        discountTemp2 = referralAmount;
      } else {
        discountTemp2 = subtotaltemp;
      }
      setReferralDiscount(discountTemp2);
    }

    setAllTotal(itemT + deliveryItemTotal + VATCharge + InsuranceCharge - discountTemp - discountTemp2);
  }

  const cngDeliveryProductVal = () => {
    let products = getValues("delivery_products");
    let itemT = 0;
    products.forEach((i) => {
      if (i?.total !== "") {
        itemT += parseFloat(i?.total);
      }
    });
    setDeliveryItemTotal(itemT);
    setAllTotal(itemTotal + itemT + VATCharge + InsuranceCharge);
  }

  const delItems = (index) => {
    if (fileds2.length <= 1) return false;
    remove2(index);
    cngProductVal();
  }

  const delDeliveryItems = (index) => {
    if (fileds1.length <= 1) return false;
    remove1(index);
    cngDeliveryProductVal();
  }

  const onSubmit = (data) => {
    document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });

    let pListTemp = data?.products?.map(i => {
      if (i?.category_id === 0) {
        return { ...i, item_name: 'Other- ' + i?.item_name };
      }
      return i;
    });

    data = { ...data, products: pListTemp, pickup_date: dayjs(data?.pickup_date).format("YYYY-MM-DD"), itemTotal: itemTotal, discountVal: discountVal, discountAmount: discountAmount, referralDiscount: referralDiscount };

    let deliveryItemList = [];
    if (data?.is_delivery) {
      deliveryItemList = data?.delivery_products?.map(i => {
        if (i?.category_id === 0) {
          return { ...i, item_name: 'Other- ' + i?.item_name };
        }
        return i;
      });
      data = { ...data, delivery_products: deliveryItemList };
    }
    saveStep1Data(data);
  }

  return (<>
    <div className={`${styles.StepOneForm}`}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <div className={`${styles.StepOneFormFull}`}>
              <div className={`FormHalfGroup`}>
                <FormControl fullWidth>
                  <InputLabel>Do you have a registered company in UK?*</InputLabel>
                  <Controller
                    control={control}
                    {...register("registered_company", { required: "Please select one" })}
                    render={({ field }) => (<Select
                      label="Do you have a registered company in UK?*"
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        setIsRegCompany(e.target.value);
                      }}
                    >
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                    </Select>)}
                  />
                </FormControl>
                {errors.registered_company && (<span className={`ErrorM`}>{errors?.registered_company?.message}</span>)}
              </div>
              {isRegCompany === "Yes" && (<>
                <div className={`FormHalfGroup`}>
                  <Controller
                    control={control}
                    {...register("company_name", { required: "This field is Required" })}
                    render={({ field }) => (<TextField {...field} label="If Yes, please mention the name of the company?*" variant="outlined" />)}
                  />
                  {errors.company_name && (<span className={`ErrorM`}>{errors?.company_name?.message}</span>)}
                </div>
                <div className={`FormHalfGroup`}>
                  <FormControl fullWidth>
                    <InputLabel>If Yes, are you shipping the goods in the name of the company?*</InputLabel>
                    <Controller
                      control={control}
                      {...register("company_shipping", {
                        required: "Please select one",
                      })}
                      render={({ field }) => (<Select label="If Yes, are you shipping the goods in the name of the company?*" {...field}>
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>)}
                    />
                  </FormControl>
                  {errors.company_shipping && (<span className={`ErrorM`}>{errors?.company_shipping?.message}</span>)}
                </div>
              </>
              )}
              <div className={`FormHalfGroup`}>
                <FormControl fullWidth>
                  <InputLabel>Have you got insurance?*</InputLabel>
                  <Controller
                    control={control}
                    {...register("insurance", { required: "Please select one" })}
                    render={({ field }) => (<Select {...field} label="Have you got insurance?*">
                      <MenuItem value="Yes">Yes</MenuItem>
                      <MenuItem value="No">No</MenuItem>
                      <MenuItem value="Not Interested">Not Interested</MenuItem>
                    </Select>)}
                  />
                </FormControl>
                {errors.insurance && (<span className={`ErrorM`}>{errors?.insurance?.message}</span>)}
              </div>
            </div>

            <FormControlLabel
              control={
                <Checkbox
                  checked={isDeliveryProducts}
                  {...register("is_delivery")}
                  onChange={(e) => {
                    setIsDeliveryProducts(e.target.checked);
                    if (e.target.checked) {
                      setAllTotal(itemTotal + deliveryItemTotal + VATCharge + InsuranceCharge);
                    } else {
                      setAllTotal(itemTotal + VATCharge + InsuranceCharge);
                    }
                    cngDeliveryProductVal();
                  }}
                />
              }
              label="Book a Delivery"
              className={`${styles.CheckBox} CheckBox`}
            />

            {isDeliveryProducts && (<DeliveryProductComponent fileds={fileds1} append={append1.bind(this)} errors={errors} control={control} setValue={setValue.bind(this)} register={register} clearErrors={clearErrors.bind(this)} watch={watch.bind(this)} cngProductVal={cngDeliveryProductVal.bind(this)} delItems={delDeliveryItems.bind(this)} />)}

            <ProductComponent fileds={fileds2} append={append2.bind(this)} errors={errors} control={control} setValue={setValue.bind(this)} register={register} clearErrors={clearErrors.bind(this)} watch={watch.bind(this)} cngProductVal={cngProductVal.bind(this)} delItems={delItems.bind(this)} />

            <div className={`${styles.StepOneFormFull}`} style={{ margin: '30px 0' }}>
              <div className={`${styles.StepOneFormSmall} ${styles.StepOneFormSmallNew1}`}>
                <div className={`FormHalfGroup`} style={{ width: '100%' }}>
                  <Controller
                    control={control}
                    {...register("pickup_date", { required: "Please select pick up date" })}
                    render={({ field }) => (<DatePicker
                      {...field}
                      minDate={dayjs()}
                      label="Pickup Date"
                      format="DD/MM/YYYY"
                    />)}
                  />
                  {errors.pickup_date && (<span className={`ErrorM`}>{errors?.pickup_date?.message}</span>)}
                </div>
                <div>
                  <div className={`FormHalfGroup`} style={{ width: '100%' }}>
                    <Controller
                      control={control}
                      {...register("notes")}
                      render={({ field }) => (<TextField {...field} label="Booking Notes" variant="outlined" multiline rows={4} />)}
                    />
                  </div>
                </div>
                <div>
                  <FormControlLabel
                    className={`${styles.CheckBox} CheckBox`}
                    label="I have read and agree to the prohibited & restricted items list*"
                    control={<Checkbox {...register("is_accept", { required: true })} />}
                  />
                  {errors?.is_accept && (<p className={`${styles.ErrorM}`}>Please accept terms & condition</p>)}
                </div>
              </div>
              <div className={`${styles.StepOneFormSmall} ${styles.StepOneFormSmallNew2}`}>
                <ul className={`${styles.CostUL}`}>
                  <li>
                    <p className={`${styles.CostTitle}`}>No of Items:</p>
                    <p className={`${styles.CostNo}`}>{noOfItems}</p>
                  </li>
                  <li>
                    <p className={`${styles.CostTitle}`}>Item Subtotal:</p>
                    <p className={`${styles.CostNo}`}>
                      £{itemTotal?.toFixed(2)}
                    </p>
                  </li>
                  {(deliveryItemTotal > 0 && isDeliveryProducts) && <li>
                    <p className={`${styles.CostTitle}`}>Delivery Subtotal:</p>
                    <p className={`${styles.CostNo}`}>
                      £{deliveryItemTotal?.toFixed(2)}
                    </p>
                  </li>}
                  {discountVal > 0 && <li>
                    <p className={`${styles.CostTitle}`}>Membership Discount({discountVal}%):</p>
                    <p className={`${styles.CostNo}`}>-£{discountAmount.toFixed(2)}</p>
                  </li>}
                  {referralDiscount > 0 && <li>
                    <p className={`${styles.CostTitle}`}>Referral Discount:</p>
                    <p className={`${styles.CostNo}`}>-£{referralDiscount.toFixed(2)}</p>
                  </li>}
                  <li>
                    <p className={`${styles.CostTitle}`}>Total VAT:</p>
                    <p className={`${styles.CostNo}`}>£0.00</p>
                  </li>
                  <li>
                    <p className={`${styles.CostTitle}`}>Insurance Charges:</p>
                    <p className={`${styles.CostNo}`}>£0.00</p>
                  </li>
                  <li>
                    <p className={`${styles.CostTitle} ${styles.Big}`}>Total:</p>
                    <p className={`${styles.CostNo} ${styles.Big}`}>£{allTotal?.toFixed(2)}</p>
                  </li>
                </ul>
              </div>
            </div>

            <div className={`${styles.StepBUSec}`}>
              <button className={`${styles.Next}`} type="submit">Next</button>
            </div>
          </div>
        </form>
      </LocalizationProvider>
    </div>
  </>);
}

export default Step1;